import * as React from "react";

import DeprecatedButton from "@v1/components/designSystem/button/Button";
import { DeprecatedEmptyState } from "@v1/components/designSystem/empty-state/EmptyState";
import { FolderSearch } from "lucide-react";
import { useNavigate } from "react-router-dom";

type NoMatchingProjectsProps = {
  searchQueryInputValue: string;
};

const NoMatchingProjects: React.FC<NoMatchingProjectsProps> = ({
  searchQueryInputValue,
}) => {
  const navigate = useNavigate();

  return (
    <DeprecatedEmptyState
      title={`No results matching "${searchQueryInputValue}"`}
      description="Start building with Replo. We can't wait to bring your ideas to life!"
      icon={<FolderSearch className="icon-size-default" />}
      UNSAFE_className="py-[15%]"
    >
      <DeprecatedButton
        size="base"
        variant="primary"
        onClick={() => navigate("../project/new")}
      >
        New Project
      </DeprecatedButton>
    </DeprecatedEmptyState>
  );
};

export default NoMatchingProjects;
